<template>
  <div>
    <details-base class="mb20" :details="details" />
    <feed-information class="mb20" :detailsA="details" />
    <input-information class="mb20" :details="details" />
    <estimated-results ref="EstimatedResults" class="mb20" :isAdd="isAdd" :details="details" />
  </div>
</template>

<script>
import {getRequest} from '@/components/Common/Utils/Utils'
import DetailsBase from './EstimateComponents/DetailsComponents/DetailsBase.vue'
import FeedInformation from './EstimateComponents/DetailsComponents/FeedInformation.vue'
import InputInformation from './EstimateComponents/DetailsComponents/InputInformation.vue'
import EstimatedResults from './EstimateComponents/DetailsComponents/EstimatedResults.vue'
import { mapMutations } from 'vuex'
export default {
  components:{
    DetailsBase,FeedInformation,InputInformation,EstimatedResults
  },
  data(){
    return {
      isAdd: true,
      estimateId: getRequest('id'),
      details: {},
      arrField: {}
    }
  },
  mounted(){
    this.getDetails()
    this.getInfor()
  },
  methods:{
    ...mapMutations('estimate',['setDataDictionary']),
    //获取预估记录
    getDetails() {
      if (this.estimateId)
        this.$http
          .get(`/sat-maximization/prediction/detail?id=${this.estimateId}`)
          .then((res) => {
            let { success, data } = res || {};
            if (success) {
              this.details = data
              let {prediction} = data || {}
              let {predictionType: predictionTypeCode} = prediction || {}
              this.$refs.EstimatedResults.init({predictionTypeCode});
           }
          });
    },
    getInfor(){
      let params = {
        code: "EnergySystem,AminoAcidSystem,PhosphorusSystem,genderOption,currentFeedIntakeOption,actualMeanIntakeOrIntakeCurve,observedMeanIntakeCurveType,CurrentPDPatternNumber,CurrentGrowthPerformanceNumber"
      }
      this.$get('/sat-maximization/dict/listDictByCode',params).then(res => {
        let {success,data=[]} = res || {}
        if(success){
          data.forEach(el => {
            this.arrField[el.code] = el.dictList || []
          })
          this.setDataDictionary(this.arrField)
        }
      })
    },
  }
}
</script>